import { instance } from "libs/api";

import { ApiRoutesMarketing } from "../../constants";
import { DeleteMarketingFlowStepPayload } from "../../marketing.types";

export const requestDeleteMarketingFlowStep = async ({
  flowId,
  stepId
}: DeleteMarketingFlowStepPayload): Promise<{ ok: boolean }> => {
  return await instance.delete(
    `${ApiRoutesMarketing.Flows}/${flowId}/steps/${stepId}`
  );
};
